/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  var Tooltip, d3, d3Tip, swal;

  swal = require('sweetalert');

  Tooltip = require("imports/Tooltip");

  d3 = require("d3");

  d3Tip = require("d3-tip");

  d3.tip = d3Tip;

  window.trendsInteractivity = {
    changeData: function(data_in, x_axis_var_in, x_axis_var_time_check_in, date_pattern_in, current_interval_in) {
      var _self, diff, end, i, j, len, ref, start;
      _self = this;
      this.x_axis_var = x_axis_var_in;
      this.x_axis_var_time_check = x_axis_var_time_check_in;
      this.date_pattern = date_pattern_in;
      this.current_interval = current_interval_in;
      this.parseDate = d3.time.format(`${this.date_pattern}`).parse;
      data_in.forEach((function(d) {
        return d.date = _self.parseDate(d.date.toString());
      }));
      if (this.saved_line) {
        this.update_current_search_init = true;
        ref = this.data;
        for (j = 0, len = ref.length; j < len; j++) {
          i = ref[j];
          i.count = 0;
        }
        if (this.data.length > data_in.length) {
          diff = this.data.length - data_in.length;
          i = 0;
          while (i < data_in.length) {
            this.data[i + diff].count = data_in[i].count;
            i += 1;
          }
        } else {
          diff = data_in.length - this.data.length;
          i = 0;
          while (i < this.data.length) {
            this.data[i].count = data_in[i + diff].count;
            i += 1;
          }
        }
      } else {
        this.data = data_in;
      }
      this.stat_list = d3.keys(this.data[0]).filter(function(key) {
        this.x_axis_var = x_axis_var_in;
        if (key !== this.x_axis_var) {
          return key;
        }
      });
      if (this.data.length) {
        start = this.data[0];
        this.startDate = start[this.x_axis_var];
        end = this.data[this.data.length - 1];
        this.endDate = end[this.x_axis_var];
        return this.clearGraphandUpdate();
      }
    },
    brushInit: function() {
      var _self;
      _self = this;
      return this.brush = d3.svg.brush().x(this.x_scale).on("brushend", function() {
        var extent;
        extent = _self.brush.extent();
        d3.selectAll(`.brush-${_self.graph_id}`).call(_self.brush.clear());
        if (_self.x_scale.invert(extent[0]).getTime() !== _self.x_scale.invert(extent[1]).getTime()) {
          _self.pending_daterange_change = true;
          _self.startDate = _self.x_scale.invert(extent[0]);
          _self.endDate = _self.x_scale.invert(extent[1]);
          return _self.clearGraphandUpdate();
        }
      });
    },
    focusTracking: function(bodyElement) {
      var bisectDate, d0, d1, date, day, days, diff_left, diff_right, error, first_element_selected, heightCheck, hoverDate, i, j, len, maxY, maxYtemp, month, months, ref, tooltipContent, val, widthCheck, widthSet, widthSetTemp, x0, year;
      try {
        x0 = this.x_scale.invert(d3.mouse(bodyElement)[0]);
      } catch (error1) {
        error = error1;
        console.error("Focus tracking error:");
        console.error(error);
        return;
      }
      bisectDate = d3.bisector(function(d) {
        return d.date;
      }).right;
      i = bisectDate(this.data, x0, 1);
      d1 = i === this.data.length ? this.data[this.data.length - 1] : this.data[i];
      first_element_selected = false;
      d0 = this.data[i - 1];
      diff_left = d1.date.getTime() - x0.getTime();
      diff_right = x0.getTime() - d0.date.getTime();
      if (diff_left > diff_right) {
        hoverDate = d0.date;
        first_element_selected = true;
      } else {
        hoverDate = d1.date;
      }
      day = hoverDate.getDay();
      date = hoverDate.getDate();
      month = hoverDate.getMonth();
      year = hoverDate.getFullYear();
      days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      tooltipContent = [];
      switch (this.current_interval) {
        case "day":
          tooltipContent = `<p class='main-text tooltip-title'><strong>${days[day]}, ${months[month]} ${date}, ${year} </strong></p>`;
          break;
        case "week":
          tooltipContent = `<p class='main-text tooltip-title'><strong>${months[month]} ${date}, ${year} </strong></p>`;
          break;
        case "month":
          tooltipContent = `<p class='main-text tooltip-title'><strong>${months[month]}, ${year} </strong></p>`;
          break;
        case "year":
          tooltipContent = `<p class='main-text tooltip-title'><strong>${year} </strong></p>`;
      }
      maxY = 0;
      widthSet = 0;
      ref = this.keys;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        val = ref[i];
        if (first_element_selected) {
          maxYtemp = d0[this.keys[i]];
        } else {
          maxYtemp = d1[this.keys[i]];
        }
        if (maxYtemp > maxY) {
          maxY = maxYtemp;
        }
        widthCheck = this.keys[i].toString() + ": " + maxYtemp.toString();
        widthSetTemp = widthCheck.length;
        if ((this.keys.length === 1) || (this.keys[i] === "count" && this.update_current_search_init) || (this.keys[i] !== "count")) {
          tooltipContent += `<p class='main-text' id='tooltip-stats' style='color: ${this.colors[i]}'><strong> ${this.keys.length === 1 ? this.current_search : this.keys[i] === "count" ? this.current_search : this.keys[i]} : </strong>${this.format_number(maxYtemp)}</p>`;
        }
        if (widthSetTemp > widthSet) {
          widthSet = widthSetTemp;
        }
      }
      heightCheck = this.keys.length;
      this.tooltip.showTooltip(tooltipContent, d3.event);
      this.focus.style("visibility", "visible");
      return this.focus.select(".y").attr("x1", this.x_scale(hoverDate)).attr("x2", this.x_scale(hoverDate)).attr("y1", this.height - this.xAxisPadding).attr("y2", this.y_scale(maxY));
    },
    hide: function() {
      this.tooltip.hideTooltip();
      return this.focus.style("visibility", "hidden");
    }
  };

  window.TrendsLineGraph = (function() {
    //##########################################
    //#   CLASS DEFINITION FOR TRENDS GRAPH   ##
    //##########################################
    class TrendsLineGraph extends BaseLineGraph {
      constructor(graph_id, saveTrendlineToStore, getSavedLines) {
        var _self;
        super();
        this.graph_id = graph_id;
        this.saveTrendlineToStore = saveTrendlineToStore;
        this.getSavedLines = getSavedLines;
        _self = this;
        this.brushInit();
        if ($(`#${this.graph_id}-tooltip`).length > 0) {
          $(`#${this.graph_id}-tooltip`).remove();
        }
        this.svg.on("mousemove", function() {
          return _self.focusTracking(this);
        }).on("mouseout", function() {
          return _self.hide();
        });
        this.legend_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", "legend");
        this.focus = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", "focus");
        this.focus.append("line").attr("class", "y").style("stroke", "#503ABD").attr("stroke-width", "2").attr("x1", 0).attr("x2", 0).attr("y1", 0).attr("y2", 0);
        this.brush_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", `brush-${this.graph_id}`).call(this.brush).selectAll('rect').attr('height', this.height - this.xAxisPadding);
        this.dots_g = d3.select(`.transform-g-${this.graph_id}`).append("g");
        this.tooltip = Tooltip.default(`${this.graph_id}-tooltip`);
      }

      update() {
        var _self, leftPadding, rectWidth, textPadding;
        _self = this;
        // if we have data in store, use that - o.w. cleanse @data of any saved lines
        if (this.getSavedLines().length) {
          this.data = this.getSavedLines();
          if (Object.keys(this.data[0]).length > 2) {
            this.saved_line = true;
          } else {
            this.saved_line = false;
          }
        } else {
          this.data = this.data.map((datum) => {
            return {
              date: datum.date,
              count: datum.count
            };
          });
        }
        if (this.restrictObjByDate(this.data).length > 45) {
          if (this.saved_line) {
            this.fill_color = 'none';
          } else {
            this.fill_color = '#eeeeee';
          }
          this.line.interpolate("monotone");
          this.dot_check = false;
          this.stroke_width = 2;
          this.line = d3.svg.area().x(function(d) {
            return _self.x_scale(d.date);
          }).y1(function(d) {
            return _self.y_scale(d.statistic);
          }).y0(this.height - this.xAxisPadding);
        } else {
          this.fill_color = 'none';
          this.line.interpolate("linear");
          this.dot_check = true;
          this.stroke_width = 4;
          this.line = d3.svg.line().x(function(d) {
            return _self.x_scale(d.date);
          }).y(function(d) {
            return _self.y_scale(d.statistic);
          });
        }
        super.update();
        this.legend_boxes = this.legend_elements_g.selectAll("rect").data(this.stats).enter().append("rect");
        rectWidth = 15;
        textPadding = 5;
        leftPadding = 15;
        this.legend_boxes.attr("y", function(d, i) {
          if (!_self.update_current_search_init) {
            if (i === 0) {
              return 10;
            } else {
              return ((i - 1) * 20) + 10;
            }
          } else {
            return (i * 20) + 10;
          }
        }).attr("fill", function(d, i) {
          if ((_self.keys.length === 1) || (_self.keys[i] === "count" && _self.update_current_search_init) || (_self.keys[i] !== "count")) {
            return _self.colors[i];
          } else {
            return 'none';
          }
        }).attr("x", this.yAxisPadding + leftPadding).attr("width", 15).attr("height", 15).attr("display", function() {
          if (_self.stat_list.length === 1) {
            return "none";
          } else {
            return "block";
          }
        });
        this.legend_text = this.legend_elements_g.selectAll("text").data(this.stats).enter().append("text");
        this.legend_text.attr("display", function() {
          if (_self.stat_list.length === 1) {
            return "none";
          } else {
            return "block";
          }
        }).attr("fill", function(d, i) {
          return _self.colors[i];
        }).attr("y", function(d, i) {
          if (_self.update_current_search_init === false) {
            if (i === 0) {
              return 12;
            } else {
              return ((i - 1) * 20) + 12;
            }
          } else {
            return (i * 20) + 12;
          }
        }).attr("x", this.yAxisPadding + textPadding + rectWidth + leftPadding).text(function(d, i) {
          if (_self.keys.length === 1) {
            return _self.current_search;
          } else {
            if (_self.keys[i] === "count") {
              if (_self.update_current_search_init) {
                return _self.current_search;
              } else {
                return "";
              }
            } else {
              return _self.keys[i];
            }
          }
        }).attr("dy", ".73em").attr("text-anchor", "start");
        return this.x_axis_g.transition().duration(1000).call(this.x_axis).selectAll("text").attr("transform", "rotate(-45)").style("text-anchor", "end").attr("dy", ".75em").attr("dx", "-.75em");
      }

      clearGraphandUpdate() {
        this.legend_boxes.remove();
        this.legend_text.remove();
        return super.clearGraphandUpdate();
      }

      saveLine() {
        var _self;
        _self = this;
        return swal({
          buttons: ["Cancel", "Save"],
          title: 'Save Current Line',
          text: 'Name Line:',
          content: 'input',
          animation: 'slide-from-top',
          inputPlaceholder: 'Title'
        }).then(function(inputValue) {
          var i, j, len, ref;
          if (inputValue === null) {
            return false;
          }
          if (inputValue === '') {
            swal("Error", 'Please add a title.', "error");
            return false;
          }
          _self.update_current_search_init = false;
          _self.saved_line = true;
          ref = _self.data;
          for (j = 0, len = ref.length; j < len; j++) {
            i = ref[j];
            i[`${inputValue}`] = i.count;
          }
          _self.saveTrendlineToStore(_self.data);
          _self.stat_list = d3.keys(_self.data[0]).filter(function(key) {
            if (key !== _self.x_axis_var) {
              return key;
            }
          });
          return _self.clearGraphandUpdate();
        });
      }

      clearSavedLines() {
        var i, j, k, key, keys_to_delete, l, len, len1, len2, newStats, ref, ref1, stat;
        this.saved_line = false;
        keys_to_delete = d3.keys(this.data[0]).filter(function(key) {
          return key !== "date" && key !== "count";
        });
        ref = this.data;
        for (j = 0, len = ref.length; j < len; j++) {
          i = ref[j];
          for (k = 0, len1 = keys_to_delete.length; k < len1; k++) {
            key = keys_to_delete[k];
            delete i[key];
          }
        }
        newStats = [];
        ref1 = this.stats;
        for (l = 0, len2 = ref1.length; l < len2; l++) {
          stat = ref1[l];
          if (!keys_to_delete.includes(stat.name)) {
            newStats = newStats.concat([stat]);
          }
        }
        this.stats = newStats;
        this.saveTrendlineToStore(this.data);
        return this.clearGraphandUpdate();
      }

      setDateRange(newStartDate = false, newEndDate = false) {
        this.parseDate = d3.time.format(`${this.date_pattern}`).parse;
        if (newStartDate) {
          this.startDate = this.parseDate(newStartDate.replace(/\-/g, ''));
        }
        if (newEndDate) {
          this.endDate = this.parseDate(newEndDate.replace(/\-/g, ''));
        }
        return this.clearGraphandUpdate();
      }

      specificVarsInit() {
        this.text_check = false;
        this.dot_check = false;
        this.pending_daterange_change = false;
        this.radii_min = 5;
        this.radii_max = 5;
        this.dots_stroke_width = 5;
        // @dots_stroke_color = "#503ABD"
        this.background_color = "#fbfcfc";
        this.dots_fill_color = "#ffffff";
        this.text_size = 0;
        this.saved_line = false;
        this.current_search = "Current Search";
        this.update_current_search_init = true;
        return this.loader_id = "trends-loading-advanced-search";
      }

    };

    TrendsLineGraph.include(trendsInteractivity);

    return TrendsLineGraph;

  }).call(this);

}).call(globalThis);
